import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.values.js";
export var getUnreadMessages = function getUnreadMessages(conversations) {
  return Object.values(conversations).map(function (_ref) {
    var newMessages = _ref.newMessages;
    return newMessages;
  }).reduce(function (prev, current) {
    return prev + current;
  }, 0);
};